import React from "react";
import {useState,useEffect} from 'react';
import Layout from "../medicalcomponents/Layout";
import * as Icon from "react-bootstrap-icons";
import axios from "axios";
import configData from "../config.json";

const Dashboard = () => {

  if (localStorage.getItem("branchID") === null) {
    window.location.replace("/");
  }

  const [dashboardData,setDashboardData]=useState([]);
  const [stockData, setStockData] = useState([]);

  useEffect(() => {
    const getDashboardData=async()=>{
        const response=await axios.get(configData.SERVER_URL+`/medicalDashboard/${localStorage.getItem('branchID')}`);

        setDashboardData(response.data.result1 ||[]);
        setStockData(response.data.result2 ||[]);
    }
    getDashboardData();
  }, []);

  const dashboardCards = [
    {
      title: "Patient Records",
      icon: <Icon.PersonLinesFill size={35} />,
      color: "primary",
      total: dashboardData?.[0]?.totalEmployee,
    },

    {
      title: "Appointments",
      icon: <Icon.CalendarCheckFill size={35} />,
      color: "success",
      total: dashboardData?.[0]?.totalAppointment,
    },

    {
      title: "Medical Inventory",
      icon: <Icon.CapsulePill size={35} />,
      color: "warning",
      total: stockData?.[0]?.totalItems,
    },

    {
      title: "Doctors",
      icon: <Icon.HeartPulseFill size={35} />,
      color: "danger",
      total: "1",
    },
  ];

  return (
    <>

      {/* Top Banner */}
      <div
        className="p-4 p-md-5 rounded-4 shadow-sm mb-4 text-white"
        style={{
          background:
            "linear-gradient(to right, #0d6efd, #0dcaf0)",
        }}
      >

        <div className="d-flex align-items-center">
          <div
            className="bg-white text-primary rounded-circle d-flex align-items-center justify-content-center shadow me-4"
            style={{ width: "85px", height: "85px",}}
          >
            <Icon.HeartPulseFill size={40} />
          </div>

          <div>
            <h2 className="fw-bold mb-2">
              Medical Management System
            </h2>

            <p className="mb-0 fs-5">
              Welcome to the Smart Healthcare Dashboard
            </p>
          </div>

        </div>

      </div>

      {/* Statistics Cards */}

      <div className="row g-4">

        {dashboardCards.map((item, index) => (

          <div className="col-xl-3 col-lg-6 col-md-6" key={index}>

            <div
              className="card border-0 shadow-sm h-100"
              style={{ 
                borderRadius: "20px", 
                transition: "0.3s ease", 
                cursor: "pointer",
               }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-6px)";
                e.currentTarget.style.boxShadow = "0 15px 30px rgba(0,0,0,0.10)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = "0 5px 15px rgba(0,0,0,0.05)";
              }}
            >

              <div className="card-body p-4">
                <div className="d-flex justify-content-between align-items-center">
                  <div>
                    <h6 className="text-muted mb-2"> {item.title} </h6>
                    <h2 className="fw-bold"> {item.total} </h2>
                  </div>

                  <div
                    className={`bg-${item.color} text-white rounded-circle d-flex align-items-center justify-content-center shadow`}
                    style={{ width: "70px", height: "70px",}}
                  >
                    {item.icon}
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}

      </div>
    </>
  );
};

export default Dashboard;